<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="favoriteLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="favoriteError" class="mc-error">{{ favoriteError }}</div>
      <div v-if="favoriteLoaded" class="mc-products">
        <div class="mc-products__number">
          {{favorite.length}} товара
        </div>
        <ul class="mc-products__list">
          <li class="mc-products__item" v-for="product in favorite">
            <product-item :product="product" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductItem from "@/views/components/ProductItem.vue";

export default {
    beforeRouteLeave(to, from) {
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    created() {
      this.fetchFavorite();
    },
    computed: {
      ...mapGetters([
        'favorite',
        'favoriteLoading',
        'favoriteError',
        'favoriteLoaded'
      ]),
    },
    async mounted() {

    },
    methods: {
      ...mapActions([
        'fetchFavorite'
      ]),
    },
    data: () => ({
      sortShow: false
    }),
    components: {
      ProductItem

    }
}
</script>

